import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const NAMES = { olaparty: "Qwick Live", trumeet: "Trumeet" };

export const SubAgentMoveDialog = ({ open, mode, sub, onClose }) => {
  const { setReseller } = useAuth();
  const [platform, setPlatform] = useState("");
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [mine, setMine] = useState(null);
  useEffect(() => {
    if (!open || !sub) return;
    setPlatform(sub.allowed_platforms[0] || ""); setAmount(""); setNote("");
    api.get("/reseller/dashboard").then((r) => setMine(r.data.user.balances)).catch(() => {});
  }, [open, sub]);
  if (!sub) return null;
  const send = mode === "send";
  const rate = Number(sub.sub_rates?.[platform] || 0);
  const n = parseInt(amount, 10) || 0;

  const go = async () => {
    if (n <= 0) { toast.error("Enter the number of diamonds"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/reseller/subagents/${sub.id}/${send ? "transfer" : "reclaim"}`, { platform, diamonds: n, note });
      toast.success(`${send ? "Sent" : "Took back"} ${n.toLocaleString()} 💎 · your balance ${data.my_balance.toLocaleString()} · ${sub.name}: ${data.subagent_balance.toLocaleString()}`);
      api.get("/auth/reseller/me").then((r) => setReseller(r.data.reseller)).catch(() => {});
      onClose(true);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose(false)}>
      <DialogContent className="max-w-md" data-testid="subagent-move-dialog">
        <DialogHeader><DialogTitle>{send ? `Send diamonds to ${sub.name}` : `Take back diamonds from ${sub.name}`}</DialogTitle>
          <DialogDescription>{send ? "Moves diamonds from your stock to this sub-agent." : "Returns unused diamonds from this sub-agent to your stock."}</DialogDescription></DialogHeader>
        <div className="space-y-1.5"><Label className="text-xs">Platform</Label>
          <Select value={platform} onValueChange={setPlatform}><SelectTrigger data-testid="subagent-move-platform"><SelectValue /></SelectTrigger>
            <SelectContent>{sub.allowed_platforms.map((k) => <SelectItem key={k} value={k}>{NAMES[k] || k}</SelectItem>)}</SelectContent></Select></div>
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div className="rounded-md bg-zinc-50 p-2">Your balance<div className="font-mono text-base font-semibold" data-testid="subagent-move-my-balance">{(mine?.[platform]?.balance ?? 0).toLocaleString()}</div></div>
          <div className="rounded-md bg-zinc-50 p-2">{sub.name}<div className="font-mono text-base font-semibold" data-testid="subagent-move-sub-balance">{(sub.balances?.[platform]?.balance ?? 0).toLocaleString()}</div></div>
        </div>
        <div className="space-y-1.5"><Label className="text-xs">Diamonds</Label><Input type="number" min="1" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="subagent-move-amount" />
          {send && rate > 0 && n > 0 && <div className="text-[11px] text-zinc-500">At your rate ₹{rate}/diamond = ₹{(rate * n).toLocaleString("en-IN")} (collect offline)</div>}</div>
        <div className="space-y-1.5"><Label className="text-xs">Note (optional)</Label><Input value={note} onChange={(e) => setNote(e.target.value)} data-testid="subagent-move-note" /></div>
        <Button onClick={go} disabled={busy} className="w-full bg-zinc-900 hover:bg-zinc-800" data-testid="subagent-move-confirm">{busy ? "Please wait…" : send ? "Send diamonds" : "Take back"}</Button>
      </DialogContent>
    </Dialog>
  );
};
